// Module
var code = `<simple-table
    get-table-data="players_power.equipments_power_table_data"
    caption-text="Распределение игроков по силе экипировки"
    caption-url="https://confluencen.amt-games.com/pages/viewpage.action?pageId=51644157"
>
</simple-table>
`;
// Exports
module.exports = code;